import axios from 'axios'

const verifyToken = () => {
  const token = sessionStorage.getItem('token')
  const headers = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get('/api/proxy/v2/users/self', headers)
}

export default verifyToken



// WEBPACK FOOTER //
// ./src/helpers/verifyToken.js